var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Digitar Coleta")]),_c('form-collect',{ref:"formCreateCollect",attrs:{"loading":_vm.loading,"form":_vm.form},on:{"save":_vm.save,"update:form":function($event){_vm.form=$event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }